import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const greyIcon = (theme: Theme) => css`
  color: ${theme.palette.neutral[700]};
`

export const rowListItem = css`
  ${breakpoint.up('md')} {
    margin: ${size[16]};
  }
`

export const noMargin = css`
  margin: 0;

  ${breakpoint.up('sm')} {
    margin: 0;
  }
`
